<template>
	<div class="dv" >
		<img src="../../assets/images/404_icon.png" alt="" class="404_icon">
		<div class="txt">{{$t('error.msg')}}</div>
		<div class="tips">{{$t('error.worry')}}</div>
		<div class="flex_start">
			<el-button type="primary" round @click="Refresh">{{$t('error.refresh')}}</el-button>
			<el-button type="primary" plain round @click="returns">{{$t('error.back')}}</el-button>
		</div>
	</div>
</template>

<script>
		export default {
			methods: {
				Refresh() {
					this.$router.go(0)
				},
				returns() {
					this.$router.push('/')
				}
			}
		}
</script>

<style scoped>
	.dv {
		display: flex;
		flex-direction: column;
		align-items: center;
	}

	.404_icon {
		width: 515px;
		height: 300px;
	}

	.txt {
		font-size: 24px;
		color: #1A1A1A;
		font-weight: bold;
		margin: 20px 0;
	}

	.tips {
		font-size: 16px;
		color: #999;
		margin-bottom: 30px;
	}
</style>



// WEBPACK FOOTER //
// src/components/fourOneFour/fourOneFour.vue